import { Images } from '@/assets/images';
import { REGEX } from '@/constant';
import { cn } from '@/utils';

import { includes, range } from 'ramda';

import { CheckboxType, FormConfig } from '../define-document-write.type';

const initializeValue = {
	visaPayment: '',
	notarizationCosts: '',
	overtimePay: '',
	comment: '',
	officials: [],
	workplace: [],
	salaryAccount: [],
	depositSupport: [],
	nameSupport: '',
	passportDeprivation: [],
	deprivationOrther: '',
	employerTreatment: [],
	vistimsViolation: [],
};

type IValues = typeof initializeValue;
// ARF_06
export const INDICATORS_FOR_IDENTIFYING_VICTIMS_OF_HUMAN_RIGHTS_VIOLATIONS_CONFIG: FormConfig<IValues> =
	{
		initializeValue,
		title: '인권침해 피해 식별지표',
		pages: [
			{
				background: {
					src: Images.formIndicatorsForIdentifyingVictimsOfHumanRightsViolationsHighlight,
					className: 'template',
					dataSource:
						Images.formIndicatorsForIdentifyingVictimsOfHumanRightsViolations,
				},
				textAreas: [
					{
						name: 'visaPayment',
						maxHeight: 20,
						maxLength: 30,
						containerClassName: 'absolute top-[253px] left-[31%] w-[388px]',
						className: 'text-[13px]',
						regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					},
					{
						name: 'notarizationCosts',
						maxHeight: 20,
						maxLength: 10,
						containerClassName: 'absolute top-[300px] left-[59%] w-[166px]',
						className: 'text-[13px]',
						regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					},
					(values, index) => ({
						name: 'nameSupport',
						maxHeight: 20,
						maxLength: 6,
						containerClassName: cn(
							'absolute top-[513px] left-[67.6%] w-[75px]',
							includes('1', values?.depositSupport) && 'cursor-pointer'
						),
						className: 'text-[13px]',
						disabled: !includes('1', values?.depositSupport),
						regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					}),
					(values, index) => ({
						name: 'deprivationOrther',
						maxHeight: 20,
						maxLength: 7,
						containerClassName: cn(
							'absolute top-[582px] left-[55.2%] w-[80px]',
							includes('3', values?.passportDeprivation) && 'cursor-pointer'
						),
						className: 'text-[13px]',
						disabled: !includes('3', values?.passportDeprivation),
						regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					}),
					{
						name: 'overtimePay',
						maxHeight: 20,
						maxLength: 3,
						containerClassName: 'absolute top-[637px] left-[72.2%] w-7',
						className: 'text-[13px] text-center',
						regex: REGEX.ALLOW_NUMBER,
					},
					{
						name: 'comment',
						maxHeight: 110,
						maxLength: 180,
						containerClassName: 'absolute top-[916px] left-[20.2%] w-[475px]',
						className: 'text-[13px]',
						rows: 5,
						regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					},
				],
				checkboxes: [
					{
						type: CheckboxType.MULTIPLE,
						name: 'officials',
						options: ['1', '2', '3', '4'],
						classNames: [
							'absolute top-[353px] left-[173px] w-3 !h-3', // 1
							'absolute top-[353px] left-[315px] w-3 !h-3', // 2
							'absolute top-[353px] left-[403px] w-3 !h-3', // 3
							'absolute top-[353px] left-[523px] w-3 !h-3', // 4
						],
						iconType: 'square',
					},
					{
						type: CheckboxType.MULTIPLE,
						name: 'workplace',
						options: ['1', '2', '3'],
						classNames: [
							'absolute top-[401px] left-[327px] w-3 !h-3', // 1
							'absolute top-[401px] left-[380px] w-3 !h-3', // 2
							'absolute top-[401px] left-[505px] w-3 !h-3', // 3
						],
						iconType: 'square',
					},
					{
						name: 'salaryAccount',
						options: ['1'],
						classNames: [
							'absolute top-[470px] left-[166px] w-3 !h-3', // 1
						],
						iconType: 'square',
					},
					{
						name: 'depositSupport',
						options: ['1', '2'],
						classNames: [
							'absolute top-[518px] left-[166px] w-3 !h-3', // 1
							'absolute top-[539px] left-[169px] w-3 !h-3', // 2
						],
						getResetKey: (value: string) => {
							return ['nameSupport'];
						},
						iconType: 'square',
					},
					{
						type: CheckboxType.MULTIPLE,
						name: 'passportDeprivation',
						options: ['1', '2', '3'],
						classNames: [
							'absolute top-[587px] left-[166px] w-3 !h-3', // 1
							'absolute top-[587px] left-[250px] w-3 !h-3', // 2
							'absolute top-[587px] left-[378px] w-3 !h-3', // 3
						],
						getResetKey: (value: string) => {
							let result: string[] = [];
							if (includes('3', value)) {
								result = ['deprivationOrther'];
							}
							return result;
						},
						iconType: 'square',
					},
					{
						type: CheckboxType.MULTIPLE,
						name: 'employerTreatment',
						options: ['1', '2', '3'],
						classNames: [
							'absolute top-[717px] left-[254px] w-3 !h-3', // 1
							'absolute top-[717px] left-[329px] w-3 !h-3', // 2
							'absolute top-[717px] left-[405px] w-3 !h-3', // 3
						],
						iconType: 'square',
					},
					{
						type: CheckboxType.MULTIPLE,
						name: 'vistimsViolation',
						options: range(1, 17).map(String),
						classNames: [
							'absolute top-[231px] left-[661px] center w-6 h-6', // 1
							'absolute top-[290px] left-[661px] center w-6 h-6', // 2
							'absolute top-[336px] left-[661px] center w-6 h-6', // 3
							'absolute top-[386px] left-[661px] center w-6 h-6', // 4
							'absolute top-[446px] left-[661px] center w-6 h-6', // 5
							'absolute top-[516px] left-[661px] center w-6 h-6', // 6
							'absolute top-[570px] left-[661px] center w-6 h-6', // 7
							'absolute top-[608px] left-[661px] center w-6 h-6', // 8
							'absolute top-[635px] left-[661px] center w-6 h-6', // 9
							'absolute top-[673px] left-[661px] center w-6 h-6', // 10
							'absolute top-[711px] left-[661px] center w-6 h-6', // 11
							'absolute top-[738px] left-[661px] center w-6 h-6', // 12
							'absolute top-[765px] left-[661px] center w-6 h-6', // 13
							'absolute top-[793px] left-[661px] center w-6 h-6', // 14
							'absolute top-[820px] left-[661px] center w-6 h-6', // 15
							'absolute top-[942px] left-[661px] center w-6 h-6', // 16
						],
						iconType: 'circle',
					},
				],
			},
		],
	};
